import React, {Component} from 'react';
import {ButtonIcon, ButtonPrimary} from '@homeaway/react-buttons';
import {GOOGLE_COLOR__24} from '@homeaway/svg-defs/lib/defs/GOOGLE_COLOR__24';
import {SVGIcon} from '@homeaway/react-svg';
import {apiPost} from '../../util/api.client';
import Script from 'react-load-script';
import edapWrapper from '@homeaway/edap-wrapper';
import PropTypes from 'prop-types';
import ClientLogger from '../../util/clientLogger';
import authAccountTypes from '../../enums/AuthAccountTypes';
import umsSettings from '../../util/ums.settings';
import './GoogleAuthComponent.less';

class GoogleAuthComponent extends Component {
    static get propTypes() {
        return {
            actionLocation: PropTypes.string,
            enableLoading: PropTypes.func,
            disableLoading: PropTypes.func
        };
    }

    static get defaultProps() {
        return {
            enableLoading: () => {},
            disableLoading: () => {}
        };
    }

    constructor(props) {
        super(props);
        this.onClickGoogle = this.onClickGoogle.bind(this);
        this.authenticate = this.authenticate.bind(this);
        this.register = this.register.bind(this);
        this.loginAttempt = this.loginAttempt.bind(this);
        this.loginFailure = this.loginFailure.bind(this);
        this.loginSuccess = this.loginSuccess.bind(this);
        this.handleScriptError = this.handleScriptError.bind(this);
        this.handleScriptLoad = this.handleScriptLoad.bind(this);
        this.displayAppropriateButton = this.displayAppropriateButton.bind(this);
        this.googleAuthStatus = this.googleAuthStatus.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.displayGoogleLabel = this.displayGoogleLabel.bind(this);
        if (this.props.token) {
            this.register(this.props.token);
        }
    }

    loginSuccess(json) {
        this.setState({loggedIn: true});
        edapWrapper().push({
            name: 'login.success',
            data: {logintype: 'google', loginsource: 'lex', publicuuid: json.publicUuid, actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.setAuthJson(json);
        this.props.onClose();
    }

    loginFailure() {
        this.setState({loggedIn: false});
        edapWrapper().push({
            name: 'login.failure',
            data: {logintype: 'google', loginsource: 'lex', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
        this.props.handleError(this.props.lingua.read('error.generic'));
    }

    loginAttempt() {
        edapWrapper().push({
            name: 'login.attempt',
            data: {logintype: 'google', loginsource: 'lex', actionlocation: this.props.actionLocation},
            options: {'delayProcessing': true}
        });
    }

    handleJson(json, user) {
        if (json) {
            if (authAccountTypes.isNotUndefined(json.authType)) {
                let SIGNUP = this.checkAuthType(json.authType, authAccountTypes.SIGNUP);
                if (SIGNUP && umsSettings.isTCRequired(this.props.site)) {
                    let emailAddress = user.getBasicProfile().getEmail();
                    // this is the SignUp scenario, so we need to update the pageName to TermsAndConditions only for the required EU brands
                    let pageName = 'TermsAndConditions';
                    this.props.performBulkPageUpdate(pageName, emailAddress, authAccountTypes.GOOGLE, user);
                    this.props.disableLoading();
                } else {
                    let umsOnly = this.checkAuthType(json.authType, authAccountTypes.UMS);
                    if (SIGNUP || umsOnly) {
                        this.register(user);
                    } else {
                        this.authenticate(user);
                    }
                }
            }
        }
    }

    checkAuthType(accountType, loginType) {
        return accountType.some((t) => (t === loginType));
    }

    googleAuthStatus(user) {
        const payload = {
            accessToken: user.getAuthResponse().id_token,
            authType: 'GOOGLE'
        };

        return new Promise((resolve, reject) => {
            apiPost('/auth/aam/v3/token/status', payload).then((response) => {
                if (response.status >= 200 && response.status < 400) {
                    response.json().then((json) => {
                        this.handleJson(json, user);
                        return resolve();
                    });
                }
            }).catch((e) => {
                  // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                    this.loginFailure();
                }
                return reject(e);
            });
        });
    }

    authenticate(user) {
        if (this.props.useNewEndpoints) {
            let emailAddress = user.getBasicProfile().getEmail();
            const payload = {
                'userName': emailAddress,
                'authType': 'GOOGLE',
                'secret': user.getAuthResponse().id_token,
                'rememberMe': true
            };

            return new Promise((resolve, reject) => {
                apiPost('/auth/aam/v3/authenticate', payload).then((response) => {
                    this.checkStatus(response, resolve, reject);
                    return resolve();
                }).catch((e) => {
                    return this.failLogin(e, reject);
                });
            });
        }
        return this.register(user);
    }

    register(user) {
        let emailAddress = user.getBasicProfile().getEmail();
        let token = user.getAuthResponse().id_token;
        if (this.props.useNewEndpoints) {
            const payload = {
                userName: emailAddress,
                secret: token,
                authType: 'GOOGLE',
                rememberMe: true
            };
            return new Promise((resolve, reject) => {
                apiPost('/auth/aam/v3/register', payload).then((response) => {
                    this.checkStatus(response, resolve, reject);
                    return resolve();
                }).catch((e) => {
                    return this.failLogin(e, reject);
                });
            });
        }
        const payload = {
            emailAddress,
            createTicketGrantingTicket: true,
            service: window.location.href,
            oAuthToken: token,
            oAuthType: 'GOOGLE',
            tmDeviceIdKey: '00000000-0000-0000-0000-000000000000'
        };
        return new Promise((resolve, reject) => {
            apiPost('/auth/v2/authenticate', payload).then((response) => {
                this.checkStatus(response, resolve, reject);
            }).catch((e) => {
                return this.failLogin(e, reject);
            });
        });
    }

    checkStatus(response, resolve, reject) {
        if (response.status >= 200 && response.status < 400) {
            response.json().then((json) => {
                this.loginSuccess(json);
            });
            return resolve();
        }
        this.props.disableLoading();
        this.loginFailure();
        return reject();
    }

    failLogin(e, reject) {
        this.props.disableLoading();
        this.loginFailure();
        return reject(e);
    }

    displayGoogleLabel() {
        if (this.props.expediaIconDisplayed === true) {
            return (
                <div className="Google_Label">
                    <label>{this.props.lingua.read('lex.google.icon.label')}</label>
                </div>
            );
        }
        return (
            <div/>
        );
    }

    displayAppropriateButton() {
        if (typeof this.props.authStatus !== 'undefined') {
            return (
                <div className="SocialButtons__icon">
                    <ButtonPrimary label="" className="btn--google btn-block" onClick={this.onClickGoogle}>
                        <SVGIcon className="btn--spacing" inlineFlex markup={GOOGLE_COLOR__24} />
                        <span>{this.props.lingua.read('lex.social.login.with.card.message.google')}</span>
                    </ButtonPrimary>
            </div>
            );
        }
        return (
                <div className="small">
                    <ButtonIcon circle svgMarkup={GOOGLE_COLOR__24} onClick={this.onClickGoogle} label="Google"/>
                    {this.displayGoogleLabel()}
                </div>
        );
    }


    onClickGoogle() {
        this.loginAttempt();
        let auth;
        if (window.gapi) {
            try {
                auth = window.gapi.auth2.getAuthInstance();
            } catch (error) {
                ClientLogger.logError(`An error has occurred while getting auth instance: ${error}`);
            }
            if (!auth) {
                return new Promise((resolve, reject) => {
                    reject('no auth');
                });
            }
            /* If the user is signed in, attempt to
             register them, otherwise sign in */
            if (auth.isSignedIn.get()) {
                return auth.signIn().then((user) => {
                    this.props.enableLoading();
                    return this.googleAuthStatus(user);
                }).catch((e) => {
                    // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                    if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                        this.loginFailure();
                    }
                });
            }
            return auth.signIn({
                scope: 'https://www.googleapis.com/auth/plus.login'
            }).then((user) => {
                this.props.enableLoading();
                return this.googleAuthStatus(user);
            }).catch((e) => {
                // If user denied or something else failed we log it, except if they just close pop up, no error should be displayed then
                if (typeof e === 'undefined' || e.error !== 'popup_closed_by_user') {
                    this.loginFailure();
                }
            });
        }
        this.props.disableLoading();
        return new Promise((resolve, reject) => {
            this.loginFailure();
            reject('no gapi');
        });
    }

    handleScriptError() {
        edapWrapper().push({
            name: 'generic.event',
            data: {
                eventaction: 'lexGoogleAuth.googleScriptError',
                eventcategory: 'lexGoogleAuth',
                actionlocation: this.props.actionLocation
            }
        });
    }

    handleScriptLoad() {
        /* istanbul ignore next */
        window.gapi.load('auth2', () => {
            window.gapi.auth2.init({
                client_id: '42464624060-9dvu968n052patjorlqk96iq0ucbmrjs.apps.googleusercontent.com'
            }).then(() => {
                edapWrapper().push({
                    name: 'generic.event',
                    data: {
                        eventaction: 'lexGoogleAuth.googleScriptLoad',
                        eventcategory: 'lexGoogleAuth',
                        actionlocation: this.props.actionLocation
                    }
                });
            }, (error) => {
                ClientLogger.logError(`An error has occurred while initializing google script: ${error.details}`);
            });
        }, (error) => {
            ClientLogger.logError(`An error has occurred while loading google script: ${error}`);
        });
    }

    render() {
        return (
            <div>
                <Script
                    url="https://apis.google.com/js/platform.js"
                    onError={this.handleScriptError}
                    onLoad={this.handleScriptLoad}
                />
                {this.displayAppropriateButton()}
            </div>

        );
    }
}

export default GoogleAuthComponent;
